<script setup lang="ts">
import { debounce } from 'lodash-es';
import { ref, watchEffect } from 'vue';

import { FORM_INPUT_DEBOUNCE_DEFAULT_MS } from '@modules/forms/constants';
import { TRANSLATION_GROUP_TABLE } from '@modules/tables/constants';

import type { ITableSearchEmits, ITableSearchProps } from './types';

const props = defineProps<ITableSearchProps>();

const emit = defineEmits<ITableSearchEmits>();

const innerValue = ref<string>();

function searchChange(val?: string): void {
  emit('search-update', val?.trim() || '');
}

const debouncedInput = debounce(searchChange, FORM_INPUT_DEBOUNCE_DEFAULT_MS);

function clear(): void {
  innerValue.value = '';
  debouncedInput(innerValue.value);
}

watchEffect(() => {
  innerValue.value = props.searchQuery;
});
</script>

<template>
  <div v-data-qa-auto-id="'VTableSearch'">
    <PIconField>
      <PInputIcon class="pi pi-search" />
      <PInputText
        v-model="innerValue"
        :placeholder="$getTranslation(TRANSLATION_GROUP_TABLE, 'SEARCH_PLACEHOLDER')"
        :readonly="disabled"
        size="large"
        input-id="table-search"
        name="table-search"
        class="w-full"
        autocomplete="off"
        @update:model-value="debouncedInput"
      />
      <PInputIcon
        v-if="innerValue"
        class="pi pi-times cursor-pointer"
        @click="clear"
      />
    </PIconField>
  </div>
</template>
